!function(root, app, overwatch){

    var util = overwatch.util;
    var scene = null;
    var $scene = $('[hero-scene]');
    var $elem = $scene.find('#hero-scene');

    var parallax_opts = {
        scalarX: 1,
        scalarY: 1,
        frictionX: 1,
        frictionY: 1
    };

    function setSceneHeight(height, padding){
        $scene[0].style.height = height;
        $scene[0].style.padding = padding;
    };

    function checkSceneHeight(){

        var width = util.width();
        var height = util.height();

        if(width * .4625 >= height - 66){
            setSceneHeight(height - 66 + 'px', 0);
        } else {
            setSceneHeight(null, null);
        }
    };

    function init(){

        $scene.on('mouseenter', function(){
            if(scene){
                scene.enable();
            } else if(!util.mobile() && !util.touch() && util.width() >= 768){
                scene = overwatch.parallax = new Parallax($elem[0], parallax_opts);
            }
        });

        $scene.on('mouseleave', function(){
            if(scene){
                scene.disable();
            }
        });

        overwatch.extend({ parallax: scene });

        //checkSceneHeight();

        // throttle to 30 fps
        //$(root).on('resize', _.throttle(checkSceneHeight, 32));
    };

    app.extend({ heroScene: { init: init } });

}(this, this.app, this.overwatch);
